import axios from 'axios';
import {  req } from './axiosFun';
export const list = (params) => { return req("post", "/link/drug/getList", params) };
export const getDetail = (params) => { return req("get", "/link/drug/getDetail", params) };
export const getColumns = (params) => { return req("post", "/link/drug/getColumns", params) };
export const getQRCode = (params) => { return req("post", "/link/common/getQRCode", params) };
export const addHistroy = (params) => { return req("post", "/link/searchHistory/add", params) };



// WEBPACK FOOTER //
// ./src/api/drug.js